// react
import { Fragment } from 'react';

// types
import { EntityUser, User } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// material
import { Alert, Grid, Typography, Paper, Box } from '@mui/material';

// ui
import { IconCircle } from '../IconCircle/IconCircle';

// utils
import { translateRole, translateType } from '../../../utils/translations';

// props
export interface LoanEntitiesProps {
	entities: EntityUser[];
}

export const LoanEntities = ({ entities }: LoanEntitiesProps) => {
	const { t } = useTranslation();

	return (
		<Grid item xs={12}>
			<Paper elevation={0} sx={{ overflow: 'hidden' }} variant="outlined">
				{entities.length > 0 ? (
					<Grid container sx={{ maxHeight: 200, overflowY: 'auto' }}>
						{entities.map((entity: EntityUser, i: number) => {
							return (
								<Grid item key={`entity-${i}`} xs={12}>
									<Box
										sx={(theme) => {
											return {
												backgroundColor: theme.palette.brand.grey[100],
												padding: theme.spacing(2),
											};
										}}>
										<Grid alignItems="center" container spacing={2}>
											<Grid item xs={8}>
												<Grid alignItems="center" container columnSpacing={1}>
													<Grid item>
														<IconCircle size="sm" type="entity" />
													</Grid>
													<Grid item flex={1}>
														<Typography fontWeight={600}>{entity.name}</Typography>
													</Grid>
												</Grid>
											</Grid>
											<Grid item xs={4}>
												<Typography>{translateType(entity.type, t)}</Typography>
											</Grid>
										</Grid>
									</Box>
									<Box
										sx={(theme) => {
											return {
												padding: theme.spacing(2),
											};
										}}>
										<Grid container alignItems="center" spacing={2}>
											{entity?.users?.length > 0 ? (
												entity.users.map((user: User, i: number) => {
													return (
														<Fragment key={`user-${i}`}>
															<Grid item xs={8}>
																<Grid alignItems="center" container columnSpacing={1}>
																	<Grid item>
																		<IconCircle size="sm" type="user" />
																	</Grid>
																	<Grid flex={1} item sx={{ wordBreak: 'break-word' }}>
																		<Typography>{user.fullName}</Typography>
																	</Grid>
																</Grid>
															</Grid>
															<Grid item xs={4}>
																<Typography>{translateRole(user.role, t)}</Typography>
															</Grid>
														</Fragment>
													);
												})
											) : (
												<Grid item xs={12}>
													{t('noUsers')}
												</Grid>
											)}
										</Grid>
									</Box>
								</Grid>
							);
						})}
					</Grid>
				) : (
					<Alert severity="info">{t('alert.loanNoEntities')}</Alert>
				)}
			</Paper>
		</Grid>
	);
};
